export default "_Right now, this page is only available in Czech._\n"